import { IdentityDto } from '../../shared';
import { EntityDto } from '../../entity/entity.dto';

export class AccountingSQSMessageErrorDto {
  identity = new IdentityDto();
  entity = new EntityDto();
  errorCode: string;
  errorDescription: string;
  errorDateTime: string;

  constructor(d?: AccountingSQSMessageErrorDto) {
    if (!d) {
      return;
    }
    this.identity = new IdentityDto(d.identity);
    this.entity = new EntityDto(d.entity);
    this.errorCode = d.errorCode;
    this.errorDescription = d.errorDescription;
    this.errorDateTime = d.errorDateTime;
  }
}
